import React, { useContext, useEffect } from "react";

import { LocalizationContext } from "@homeaway/react-localization-components";

import "./Contact.less";

const contactLookup = {
    es_MX_HA: {
        time: "Llámenos",
        Owner: "1-512-782-0805",
        Traveler: "52-2289800572",
        chat: {
            enabled: true,
            options: {
                uuid: "script_2761682205da62076585c25.35810340",
                tenant: "aG9tZWF3YXlnbG9iYWw",
                channel: "Mexico (Spanish) Chat",
                domain: "https://vcc-na19.8x8.com"
            }
        }
    },
    fr_CA_HA: {
        time: "Téléphone",
        Traveler: "1-902-418-5734",
        chat: {
            enabled: true,
            options: {
                uuid: "script_14161402525da5ec0f37f218.73653646",
                tenant: "aG9tZWF3YXlnbG9iYWw",
                channel: "Canada (French) Chat",
                domain: "https://vcc-na19.8x8.com"
            }
        }
    }
};

const Contact = () => {
    const siteContext = useContext(LocalizationContext);
    const methods = contactLookup[siteContext.locale] || {
        time: "",
        chat: false
    };

    useEffect(() => {
        if (
            methods.chat &&
            methods.chat.enabled &&
            window &&
            window.__8x8Chat
        ) {
            window.__8x8Chat = {
                ...window.__8x8Chat,
                ...methods.chat.options
            };
            const se = document.createElement("script");
            se.type = "text/javascript";
            se.async = true;
            se.src = `${window.__8x8Chat.domain}${window.__8x8Chat.path}/CHAT/common/js/chat.js`;

            const os = document.getElementsByTagName("script")[0];
            os.parentNode.insertBefore(se, os);
        }
    }, []);

    return (
        <div className="contact__Main">
            <h3>{methods.time}</h3>
            <p className="contact__Phone">{methods.Traveler}</p>
            <div
                className="contact__Chat"
                id="__8x8-chat-button-container-script_1921886742579f39fc0aaa38.76959543"
            />
        </div>
    );
};

export default Contact;
